import { Fetch } from 'lib';
import type { BaseAttributeSummary, Category } from 'types';

type RequestResponses = Category;

type RequestParameters = {};

type RequestBody = Prettify<
  Pick<
    Category,
    'title' | 'subSlug' | 'status' | 'iconId' | 'description' | 'seo'
  > &
    Partial<
      Record<'parentId', string> &
        Record<'relatedAttribute', BaseAttributeSummary> &
        Record<'tagsIds', string[]> &
        Record<'catalogBrandId', string>
    >
>;

const createCategory = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminCategory/createCategory',
    method: 'POST',
    body,
  });

export { createCategory };
